import { createRouter, createWebHistory } from "vue-router";
import HomePage from "./views/HomePage.vue";
import AboutUs from "./views/AboutUs.vue";
import WhyUs from "./views/WhyUs.vue";
import ContactUs from "./views/ContactUs.vue";
import AllPrograms from "./views/AllPrograms.vue";
import EnglishClasses from "./views/EnglishClasses.vue";
import CambridgeExams from "./views/CambridgeExams.vue";
import EnglishClassesForPrimary from "./views/EnglishClassesForPrimary.vue";
import EnglishClassesForSecondary from "./views/EnglishClassesForSecondary.vue";
import EnglishClassesForAdults from "./views/EnglishClassesForAdults.vue";
import EnglishClassesForCreativeWriting from "./views/EnglishClassesForCreativeWriting.vue";
import FreeTalk from "./views/FreeTalk.vue";
import MphPage from "./views/MphPage.vue";

const routes = [
  { path: "/", component: HomePage },
  { path: "/about-english-matters", component: AboutUs },
  { path: "/why-us", component: WhyUs },
  { path: "/contact", component: ContactUs },
  { path: "/our-programs", component: AllPrograms },
  { path: "/english-classes", component: EnglishClasses },
  { path: "/english-classes/cambridge-english-exams-in-petaling-jaya/", component: CambridgeExams },
  { path: "/english-classes/english-class-for-5-11-years-old-kids/", component: EnglishClassesForPrimary },
  { path: "/english-classes/english-class-for-12-19-years-old-kids/", component: EnglishClassesForSecondary },
  { path: "/english-classes/english-class-for-adults/", component: EnglishClassesForAdults },
  { path: "/english-classes/school-holidays-english-class/", component: EnglishClassesForCreativeWriting },
  { path: "/freetalk/", component: FreeTalk },
  { path: "/mph/", component: MphPage, meta: { hideNavbar: true, hideFooter: true }},
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // If the user is going back, retain scroll position
    } else {
      return { top: 0 }; // Scroll to the top for new navigations
    }
  },
});

export default router;